
    <div class="card card-yellow no-padding" [ngClass]="{'card-modal': isModal}" *ngIf="promo">
      <div class="card-content">
        <header>
          <img *ngIf="showImage" alt="Sorteio" [src]="this.imageSrcPromo"/>
          <h2>{{ promo?.title }}</h2>
          <p>
            <i class="fa fa-clock-o" aria-hidden="true"></i> {{ differenceDays }} dias restantes
          </p>
        </header>
        <p [innerHTML]="promo?.description"></p>
        <footer class="text-center">
          <button [disabled]="disableButton" class="btn" type="button" (click)="participate(promo?.id)">
            {{ buttonText }}
          </button>
          <p class="promo-info" *ngIf="!alreadyParticipating && reachLimit">Prêmios esgotados. :( Quem sabe na próxima?</p>
          <p class="promo-info" *ngIf="error">{{error}}</p>
        </footer>

        <ng-core-loading *ngIf="loading"></ng-core-loading>
      </div>
    </div>
  